<template>
    <!-- DO NOT switch show.bind to if.bind. navItem will not work if if.bind is used -->
    <nav class="navbar navbar-expand-lg px-3 py-0" ref="levelTwoContainer" id="Level_Two_Navbar">
        <!-- Small screen - burger icon menu -->
        <!-- <button
            class="navbar-toggler py-2"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#Level_Two_Menu"
            aria-controls="Level_Two_Menu"
            aria-expanded="false"
            aria-label="Toggle navigation"
        >
            <i class="fas fa-bars me-2"></i>{{ activeRouteName }}
        </button> -->
        <!-- App Menu-->
        <div class="collapse navbar-collapse" id="Level_Two_Menu">
            <!-- Left Nav -->
            <TabsAnimatedHeader :activeItem="getActiveItem">
                <ul class="navbar-nav me-auto">
                    <li
                        v-for="route in router"
                        :key="route.meta.navItem"
                        :class="`nav-item cursor-pointer ${isActivePath(route.path) ? 'active' : ''}`"
                    >
                        <button
                            class="link-btn nav-link menu-link"
                            @click="goTo(route, route.path)"
                            :ref="(el) => addItemRefs(el, route)"
                        >
                            <h6>{{ route.meta.menuName }}</h6>
                        </button>
                    </li>
                </ul>
                <!-- <nav-menu-more-button
                        routes.bind="allowableRoutes"
                        menu-container.bind="levelTwoContainer"
                        active-item.bind="activeItem"
                        if.bind="accountLoaded"
                    >
                    </nav-menu-more-button> -->
            </TabsAnimatedHeader>
        </div>
    </nav>
</template>

<script lang="ts" src="./LevelTwo.ts"></script>
<style src="./LevelTwo.scss"></style>
